import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import useIntersectionObserver from '@segment/utils/useIntersectionObserver';

var useTableOfContents = function useTableOfContents(_ref) {
  var ids = _ref.ids,
      options = _ref.options;

  var _useState = useState(),
      elementInView = _useState[0],
      setElementInView = _useState[1];

  useIntersectionObserver(ids, function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        entry = _ref3[0];

    if (entry.isIntersecting) {
      setElementInView(entry.target.id);
    }
  }, options);
  return {
    activeElementId: elementInView
  };
};

export default useTableOfContents;